export var ShipmentQuoteError;
(function (ShipmentQuoteError) {
    ShipmentQuoteError["noReturnZoneSetupForCountry"] = "It appears we cannot accept returns from your country automatically. Please reach out for help with this return";
})(ShipmentQuoteError || (ShipmentQuoteError = {}));
//# sourceMappingURL=shipmentQuoteError.js.map